<template>
  <div
    class="w-full px-2 rounded-full text-xs flex items-center break-words	"
    :class="`${color}`"
  >
    <span class="uppercase"> <slot>Status</slot></span>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
  },
};
</script>